import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  Dummyimage1,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { post } from "../../Services/ApiHandler";
const NotifyMeView = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");
  const { state } = useLocation();
  const property = state?.property;
  const [page, setPage] = useState(
    paginationData?.[path + property?.property_id]?.page ?? 1
  );
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [list, setList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    from: "",
    to: "",
    search: paginationData?.[path + property?.property_id]?.search ?? "",
  });

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path + property?.property_id]: {
        page: page,
        search: selectedFilter.search,
      },
    }));
  }, [page, selectedFilter.search]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    let { from, search, to } = selectedFilter;

    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if (from && to) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    let res = await post(
      `${URLS.NOTIFYME_VIEW}${property?.property_id}/?page=${pageNumber}`,
      payload
    );
    // console.log("wishlist res", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data ?? []);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>;
        },
      },
      {
        Header: " Room Category",
        accessor: "room_category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Service Category",
        accessor: "service_category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Time Slot",
        accessor: "timeslot",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Date",
        accessor: "notify_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: " Room Image",
        accessor: "room_image",
        Cell: ({ value, row }) => {
          return (
            <img src={value ?? Dummyimage1} alt="image" className="list-img" />
          );
        },
      },
    ],
    [page]
  );

  return (
    <div>
      <Topbar header={"Notify Me"} />
      <div className="d-flex ac-js gap-5 ">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        <div className="box_01">
          <p>
            Property Name : <b>{property?.property_name}</b>
          </p>
          <p>
            {" "}
            Property ID: <b>{property?.property_code}</b>
          </p>
        </div>
        <div className="box_01">
          <p>
            Owner Name :<b> {property?.owner_name}</b>
          </p>
          <p>
            Owner ID :<b> {property?.owner_code}</b>
          </p>
        </div>
      </div>
      <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />

        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
    </div>
  );
};

export default NotifyMeView;
